import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import Spinner from '../../../../App/Components/Spinner/Spinner'
import {
  useAppDispatch,
  useAppSelector,
} from '../../../../App/Hooks/reduxHooks'
import { ITarget } from '../../Client/ITarget'
import Form from '../../Form/Form'
import { createPersonTarget } from '../../Store/Actions'

const Add = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const history = useHistory()
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)

  const [errors] = useAppSelector(state => {
    if (!state) return [[]]

    return [state.hr.personTargets.errors]
  })

  const onFormSubmit = (personTarget: ITarget) => {
    dispatch(createPersonTarget(personTarget)).then(
      () => {
        history.push('/hr/targets/manage')
      },
      () => {
        setIsSubmitting(false)
      },
    )
    setIsSubmitting(true)
  }

  if (isSubmitting) {
    return <Spinner />
  }

  return (
    <div className={'page-layout'}>
      <h1>{t('Add target')}</h1>
      <Form onSubmit={onFormSubmit} errors={errors} />
    </div>
  )
}

export default Add
